import { ICancelChangeRequestResponseModel, IGetOrderVerificationDetailsChangeRequests } from '../../apis';

export const CHANGE_REQUESTS_LIST_ACTIONS = {
  REQUEST: 'CHANGE_REQUESTS_LIST_ACTIONS.REQUEST',
  SUCCESS: 'CHANGE_REQUESTS_LIST_ACTIONS.SUCCESS',
  FAILURE: 'CHANGE_REQUESTS_LIST_ACTIONS.FAILURE',
  CANCELED: 'CHANGE_REQUESTS_LIST_ACTIONS.CANCELED',
  REMOVE_UNREAD: 'CHANGE_REQUESTS_LIST_ACTIONS.REMOVE_UNREAD',
  CLEAR: 'CHANGE_REQUESTS_LIST_ACTIONS.CLEAR',
  REMOVE_FROM_STATE: 'CHANGE_REQUESTS_LIST_ACTIONS.REMOVE_FROM_STATE'
};

export function getChangeRequestsListRequest(payload: IGetOrderVerificationDetailsChangeRequests) {
  return {
    payload,
    type: CHANGE_REQUESTS_LIST_ACTIONS.REQUEST
  };
}

export function getChangeRequestsListSuccess(payload) {
  return {
    payload,
    type: CHANGE_REQUESTS_LIST_ACTIONS.SUCCESS
  };
}

export function getChangeRequestsListFailure(payload) {
  return {
    payload,
    type: CHANGE_REQUESTS_LIST_ACTIONS.FAILURE
  };
}

export function changeRequestCanceledAction(payload: ICancelChangeRequestResponseModel) {
  return {
    payload,
    type: CHANGE_REQUESTS_LIST_ACTIONS.CANCELED
  };
}

export function removeChangeRequestsItemUnread(payload) {
  return {
    payload,
    type: CHANGE_REQUESTS_LIST_ACTIONS.REMOVE_UNREAD
  };
}

export function clearChangeRequestList() {
  return { type: CHANGE_REQUESTS_LIST_ACTIONS.CLEAR };
}

export function removeChangeRequestFromState(payload) {
  return {
    payload,
    type: CHANGE_REQUESTS_LIST_ACTIONS.REMOVE_FROM_STATE
  };
}

export const BUYER_CONFIRM_CHANGE_REQUEST = {
  REQUEST: 'BUYER_CONFIRM_CHANGE_REQUEST.REQUEST',
  SUCCESS: 'BUYER_CONFIRM_CHANGE_REQUEST.SUCCESS',
  FAILURE: 'BUYER_CONFIRM_CHANGE_REQUEST.FAILURE'
};

export function buyerConfirmRequest(payload) {
  return {
    payload,
    type: BUYER_CONFIRM_CHANGE_REQUEST.REQUEST
  };
}

export function buyerConfirmSuccess(payload = null) {
  return {
    payload,
    type: BUYER_CONFIRM_CHANGE_REQUEST.SUCCESS
  };
}

export function buyerConfirmFailure(payload) {
  return {
    payload,
    type: BUYER_CONFIRM_CHANGE_REQUEST.FAILURE
  };
}

export const EDIT_CHANGE_REQUEST = {
  REQUEST: 'EDIT_CHANGE_REQUEST.REQUEST'
};

export interface IUpdateChangeRequestPayload {
  changeRequestId: number;
  dayDiff: number;
  reasonTypeId: number;
  reasonTypeDescription: string;
  supplierDate?: string;
  supplierQuantity?: number;
  supplierUnitPrice?: number;
}
export function updateChangeRequest(payload: IUpdateChangeRequestPayload) {
  return {
    payload,
    type: EDIT_CHANGE_REQUEST.REQUEST
  };
}

export const SUPPLIER_CONFIRM_CHANGE_REQUEST = {
  REQUEST: 'SUPPLIER_CONFIRM_CHANGE_REQUEST.REQUEST',
  SUCCESS: 'SUPPLIER_CONFIRM_CHANGE_REQUEST.SUCCESS',
  FAILURE: 'SUPPLIER_CONFIRM_CHANGE_REQUEST.FAILURE'
};

export function supplierConfirmChangeRequest(payload) {
  return {
    payload,
    type: SUPPLIER_CONFIRM_CHANGE_REQUEST.REQUEST
  };
}

export function supplierConfirmChangeRequestSuccess(payload) {
  return {
    payload,
    type: SUPPLIER_CONFIRM_CHANGE_REQUEST.SUCCESS
  };
}

export function supplierConfirmChangeRequestFailure() {
  return {
    type: SUPPLIER_CONFIRM_CHANGE_REQUEST.FAILURE
  };
}
